export enum JOB_TYPE{
  ROOF = 'Roof',
  SOLAR = 'Solar',
  HVAC = 'HVAC'
}